import axios from "axios";
import Vue from "vue";
import { URL_BASE, TOKEN } from "@/helper/constants";
import { TokenService, CountryService } from "@/services/storage.service";

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: `${URL_BASE}`
  });
  if (TOKEN) {
    instance.defaults.headers.common["Authorization"] = `${TOKEN}`;
  }
  // instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  instance.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response && error.response.status === 401) {
        TokenService.removeToken();
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export default createAxiosInstance;



// WEBPACK FOOTER //
// ./src/services/Api.js